<template>
  <v-btn class="btn-secondary" outlined :small="small" @click="toggle">
    <v-icon left>{{ shown ? 'mdi-eye-off' : 'mdi-translate' }}</v-icon>
    {{ shown ? 'پنهان کردن فیلدهای انگلیسی' : 'نمایش فیلدهای انگلیسی' }}
  </v-btn>
</template>

<script>
export default {
  name: "EnglishFieldsToggle",

  props: {
    small: {type: Boolean, default: false},
  },

  computed: {
    shown() {
      return this.$store.state.showEnglishFields
    },
  },

  methods: {
    toggle() {
      this.$store.commit('setShowEnglishFields', !this.shown)
    },
  },
}
</script>
